<template>
  <div class="animated fadeIn">
    <component-header
      title="View Stock Details"
      :hasSearch="false"
      :hasReload="false"
      :hasClear="false"
      :hasCreate="false"
    />
    <transition name="fade">
      <b-card
        border-variant="info"
        header-bg-variant="primary"
        header-text-variant="white"
        class="card-wrap"
        style="min-height: 400px"
      >
        <b-table
          :items="stockData"
          :dark="false"
          :hover="true"
          :striped="striped"
          :bordered="bordered"
          :small="small"
          :fixed="fixed"
          responsive="sm"
          id="my-table"
          :current-page="currentPage"
          :per-page="perPage"
          thead-class="header"
          class="mt-3"
          show-empty
          :fields="Column"
          :no-border-collapse="true"
          @filtered="onFilter"
        >
          <template slot="empty">
            <div v-if="isDisableRadio" class="text-center">
              <span><b>Loading...</b></span>
            </div>
            <div v-else class="text-center">No data available.</div>
          </template>
        </b-table>
        <b-pagination
          style="float: right"
          v-model="currentPage"
          :total-rows="filterCount"
          :per-page="perPage"
          prev-text="Prev"
          next-text="Next"
          aria-controls="myHistory"
          hide-goto-end-buttons
        ></b-pagination>
      </b-card>
    </transition>
  </div>
</template>

<script>
import moment from "moment";
import ComponentHeader from "@/components/componentNewHeader";
export default {
  name: "viewStockDetails",
  components: {
    ComponentHeader,
  },
  data() {
    return {
      perPage: 10,
      isDisableRadio: false,
      striped: false,
      bordered: true,
      small: false,
      fixed: false,
      currentPage: 1,
      loading: false,
      currentUser: "",
      filterCount: 0,
      Column: [
        {
          key: "orderId",
          label: "ORDER",
        },
        {
          key: "customerName",
          label: "CUSTOMER NAME",
        },
        {
          key: "createdAt",
          label: "ORDER DATE",
        },
        {
          key: "itemName",
          label: "ITEM NAME",
        },
        {
          key: "itemqty",
          label: "ITEM QUANTITY",
        },
      ],
    };
  },
  computed: {
    stockData() {
      let data = this.$store.getters["inventory/GetStockDetails"];
      let stockList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.map((obj) => {
          let arrayObj = {
            orderId: obj.orderId,
            customerName: obj.deliveryAddress.address.fullName,
            createdAt: this.getProperDate(obj.createdAt),
            itemName: obj.items[0].name,
            itemqty: obj.items[0].qty,
            ...obj,
          };
          stockList.push(arrayObj);
        });
        return stockList;
      } else {
        return [];
      }
    },
  },
  methods: {
    getProperDate(data) {
      if (data != null) {
        let date = new Date(data);

        return moment(String(date)).format("DD/MM/YYYY");
      } else {
        return "Unavailable";
      }
    },
    async getStockdetails() {
      this.loading = true;
      await this.$store
        .dispatch("inventory/stockDetails", {
          providerId: this.currentUser.providerId,
          itemId: this.currentUser.itemId,
          fromDate: this.currentUser.fromDate,
          toDate: this.currentUser.toDate,
        })
        .then((data) => {
          if (data.message) {
            this.$toasted.error(data.message);
            this.loading = false;
          }
          this.loading = false;
        });
    },
    onFilter(list) {
      this.filterCount = list.length;
      this.currentPage = 1;
    },
  },
  mounted() {
    this.currentUser = this.$route.params.userData;
    let data = this.$store.getters["inventory/GetStockDetails"];
    // if (!data || !data.length) {
    this.getStockdetails();
    // }
  },
};
</script>
